export default __webpack_public_path__ + "static/media/contactus-logo.4d1dcf95.png";